import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=5eb3c6a5&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=js&"
export * from "./Department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3c6a5",
  null
  
)

export default component.exports